import React from 'react';
import Link from './Link';

type HelpButtonProps = {
    onClick: () => void;
};

const HelpButton = ({ onClick }: HelpButtonProps): JSX.Element => {
    return (
        <Link
            cssName="help-text-link"
            onClick={onClick}
        >
            <span className="icon-glyph icon-help" />
            Help
        </Link>
    );
};

export default HelpButton;
